// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"13":"8b1f4d4c","237":"3fb57c4a","304":"e2d0d7ca","309":"e6006b86","727":"3efed3a5","867":"eb53d9a7"}[chunkId] + ".chunk.js";
};